import { ComponentType } from '../../registries/types/propTypes';
import { ContentCardProps } from '../../../components';
import { CMSTransformerDataType } from '../../types/common';

const transformContentCard = (data: CMSTransformerDataType): ContentCardProps => {
  let transformedContentDetail = {};
  if (data) {
    transformedContentDetail = {
      type: data?.content_type,
      resourceType: data?.file_type,
      imageList: data?.banner?.images?.map((banner: CMSTransformerDataType) => ({
        url: banner.image.url,
        altText: banner.alt_text,
        viewport: banner.viewport,
      })),
      tag: data?.tag,
      title: data?.display_title,
      description: data?.description,
      time: data?.time,
      date: data?.date,
      backgroundColor: data?.background?.color,
      color: data?.color?.color,
      themeColor: data?.theme_color?.color?.color,
      themeShade: data?.theme_color?.theme?.theme,
      size: data?.size,
      startDate: data?.start_date,
      firstAccountTypeTitle: data?.primary_account_type?.label,
      secondAccountTypeTitle: data?.secondary_account_type?.label,
      firstAccountTypeDate: data?.primary_account_type?.date,
      secondAccountTypeDate: data?.secondary_account_type?.date,
      url: data?.url,
    };
  }
  return {
    componentType: ComponentType.content_card,
    ...transformedContentDetail,
  };
};

export default transformContentCard;
